module.exports = __webpack_public_path__ + "img/temoignage-9-rounded.1c12b026.jpg";